/**
 * @description Only two breakpoints been introduced in the new DawnUI specs.
 */
export const BreakpointSizeV2 = {
  medium: 1024,
  large: 1920,
};

export enum BreakpointV2 {
  Medium = 'medium',
  Large = 'large',
}

export const MinBreakpointV2 = {
  medium: `(min-width: ${BreakpointSizeV2.medium}px)`,
  large: `(min-width: ${BreakpointSizeV2.large}px)`,
};

export const MaxBreakpointV2 = {
  medium: `(max-width: ${BreakpointSizeV2.medium - 1}px)`,
  large: `(max-width: ${BreakpointSizeV2.large - 1}px)`,
};
